import PropTypes from 'prop-types';

import BridleCarriage from './BridleCarriage';
import Shoes from './Shoes';

const EquipmentItem = ({ type, ...props }) =>
  type === 'shoes' ? (
    <Shoes {...props} />
  ) : (
    <BridleCarriage type={type} {...props} />
  );

EquipmentItem.propTypes = {
  type: PropTypes.oneOf(['bridle', 'carriage', 'shoes']).isRequired,
};

export default EquipmentItem;
